module.exports = __webpack_public_path__ + "static/assets/424584aa0d2284485934a8edf4645566.png";